import { Box } from '@mui/material'
import { useSettingsTableData, useUpdateTableData } from './TabsDataIn.data'
import { TemplateParameterTable } from '../Tables/TemplateParameter.MUITable'
import { TemplateParametersDataType } from '../Tables/Tables.types'
import { useRef, useState } from 'react'
import { useIsReadOnly } from 'Common/Hooks/useIsReadOnly.hooks'
import toast from 'react-hot-toast'
import { GridRowId } from '@mui/x-data-grid-premium'
import { SaveParameters } from './SaveParameters.view'
import { RunPlanParameters } from 'Features/EditSettings/EditSettings.types'
import { useRunPlan } from 'Features/EditSettings/EditSettings.data'
import { useNavigate } from 'react-router-dom'

export const TemplateParametersTab = ({ planId }: TabProps) => {
  const navigate = useNavigate()
  const updatedDataRef = useRef<Record<GridRowId, TemplateParametersDataType>>(
    {}
  )
  const [isUpdatePending, setIsUpdatePending] = useState(false)
  const parameterName = 'template-parameters'
  const { data, isLoading } = useSettingsTableData(planId, parameterName)
  const { readOnly } = useIsReadOnly(planId)
  const onSuccess = () => {
    toast.success('Parameters updated successfully.')
  }
  const onError = () => {
    toast.error('Failed to update parameters.')
  }
  const { mutate: updateBatchParameters, isLoading: isUpdating } =
    useUpdateTableData(onSuccess, onError)

  const updateTableData = (
    data: Record<GridRowId, TemplateParametersDataType>
  ) => {
    updatedDataRef.current = { ...updatedDataRef.current, ...data }
    if (Object.keys(updatedDataRef.current).length > 0) {
      setIsUpdatePending(true)
    }
    console.log('Updated data:', updatedDataRef.current)
  }

  const handleUpdate = () => {
    updateBatchParameters({
      planId,
      table: parameterName,
      data: Object.values(updatedDataRef.current),
    })
  }
  const onPlanRunInitiatedSuccess = () => {
    navigate('/')
  }

  const onPlanRunInitiatedError = (message: string) => {
    toast.error(message)
  }

  const { mutate: run, isLoading: isRunning } = useRunPlan(
    onPlanRunInitiatedSuccess,
    onPlanRunInitiatedError
  )

  const [runPlanParams, setRunPlanParams] = useState<RunPlanParameters>({
    extractData: false,
    unconstrainedPlan: true,
  })

  const handleRunPlan = () => {
    setRunPlanParams({
      ...runPlanParams,
      unconstrainedPlan: true,
    })

    run({
      planId: planId,
      parameters: runPlanParams,
    })
  }

  return (
    <Box padding={0} marginTop={2}>
      <TemplateParameterTable
        data={data ?? []}
        isLoading={isLoading}
        updateTableData={updateTableData}
        updateParametersData={() => {}} // TODO: Implement upload functionality if needed
        isUploading={false}
      />
      <SaveParameters
        handleUpdate={handleUpdate}
        isDisabled={
          isLoading || readOnly || !isUpdatePending || isUpdating || isRunning
        }
        isRunning={isLoading || isUpdating}
        handleRunPlan={handleRunPlan}
      />
    </Box>
  )
}
